<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="用户管理" name="1">
          <CustomerCheckin @outCheckin="outCheckin" :id="home_id" />
        </el-tab-pane>
        <el-tab-pane label="历史入住记录" name="2">
          <CustomerCheckinLog ref="CustomerCheckinLog" :id="home_id" />
        </el-tab-pane>
      </el-tabs>

    </div>

  </div>
</template>

<script>
import ErpTree from "../../Common/erp-tree";
import CustomerCheckin from "./CustomerCheckin";
import CustomerCheckinLog from "./CustomerCheckinLog";
import ErpTreeStatus from "../../Common/erp-tree-status";
export default {
  name: "CustomerCheckinIndex",
  components: {ErpTreeStatus, CustomerCheckinLog, CustomerCheckin, ErpTree},
  data(){
    return{
      home_id:0,
      activeName:'1'
    }
  },
  methods:{
    nodeClick(data){
      if(data.tree[data.tree.length-1].type==='room'){
        this.home_id=data.tree[data.tree.length-1].id;
      }
    },
    outCheckin(){
      var that=this;
      that.$refs.CustomerCheckinLog.getData(that.home_id,1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(common.scss);
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerCheckinIndex.vue